/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance, h, H as Host } from './index-C_ZKddLG.js';
import { B as BaseWebComponent } from './base-web-component-D909Fl-Y.js';
import './common-D-vggmh2.js';
import { c as createPropDefinition, n as normalizeString } from './normalizers-BNeak4hj.js';
import { l as labelProp } from './label-FtX-skKy.js';
import './variant-quote-ClYWonZq.js';
import { I as IconFC } from './component-BjVFpeYY.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './label-w3T7Y2ih.js';
import './tslib.es6-QNbPBOk5.js';
import './bem-registry-3ondDImf.js';
import './clsx-COFh-Vc8.js';

const iconsProp = createPropDefinition('icons', 'kolicon-logo', normalizeString);

const iconPropsConfig = {
    required: [iconsProp, labelProp],
};

const defaultStyleCss = "@font-face {\n  font-family: \"kolicons\";\n  src: url(\"kolicons.eot?t=1788937554327\"); /* IE9*/\n  src: url(\"kolicons.eot?t=1788937554327#iefix\") format(\"embedded-opentype\"), url(\"kolicons.woff2?t=1788937554327\") format(\"woff2\"), url(\"kolicons.woff?t=1788937554327\") format(\"woff\"), url(\"kolicons.ttf?t=1788937554327\") format(\"truetype\"), url(\"kolicons.svg?t=1788937554327#kolicons\") format(\"svg\"); /* iOS 4.1- */\n}\n@layer kol-component {\n  [class^=kolicon-], [class*=\" kolicon-\"] {\n    font-family: \"kolicons\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1em;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  .kolicon-alert-error::before {\n    content: \"\\ea01\";\n  }\n  .kolicon-alert-info::before {\n    content: \"\\ea02\";\n  }\n  .kolicon-alert-success::before {\n    content: \"\\ea03\";\n  }\n  .kolicon-alert-warning::before {\n    content: \"\\ea04\";\n  }\n  .kolicon-check::before {\n    content: \"\\ea05\";\n  }\n  .kolicon-chevron-double-left::before {\n    content: \"\\ea06\";\n  }\n  .kolicon-chevron-double-right::before {\n    content: \"\\ea07\";\n  }\n  .kolicon-chevron-down::before {\n    content: \"\\ea08\";\n  }\n  .kolicon-chevron-left::before {\n    content: \"\\ea09\";\n  }\n  .kolicon-chevron-right::before {\n    content: \"\\ea0a\";\n  }\n  .kolicon-chevron-up::before {\n    content: \"\\ea0b\";\n  }\n  .kolicon-cogwheel::before {\n    content: \"\\ea0c\";\n  }\n  .kolicon-cross::before {\n    content: \"\\ea0d\";\n  }\n  .kolicon-eye-closed::before {\n    content: \"\\ea0e\";\n  }\n  .kolicon-eye::before {\n    content: \"\\ea0f\";\n  }\n  .kolicon-house::before {\n    content: \"\\ea10\";\n  }\n  .kolicon-kolibri::before {\n    content: \"\\ea11\";\n  }\n  .kolicon-link-external::before {\n    content: \"\\ea12\";\n  }\n  .kolicon-link::before {\n    content: \"\\ea13\";\n  }\n  .kolicon-minus::before {\n    content: \"\\ea14\";\n  }\n  .kolicon-plus::before {\n    content: \"\\ea15\";\n  }\n  .kolicon-settings::before {\n    content: \"\\ea16\";\n  }\n  .kolicon-sort-asc::before {\n    content: \"\\ea17\";\n  }\n  .kolicon-sort-desc::before {\n    content: \"\\ea18\";\n  }\n  .kolicon-sort-neutral::before {\n    content: \"\\ea19\";\n  }\n  .kolicon-up::before {\n    content: \"\\ea1a\";\n  }\n  .kolicon-version::before {\n    content: \"\\ea1b\";\n  }\n}\n@layer kol-component {\n  .kol-icon {\n    color: inherit;\n    display: inline-block;\n    font-size: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n  }\n}";

const KolIcon = class extends BaseWebComponent {
    constructor(hostRef) {
        super();
        registerInstance(this, hostRef);
    }
    watchIcons(value) {
        iconsProp.apply(value, (v) => this.setRenderProp('icons', v));
    }
    watchLabel(value) {
        labelProp.apply(value, (v) => this.setRenderProp('label', v));
    }
    componentWillLoad() {
        this.initRenderProps(iconPropsConfig);
        iconsProp.apply(this._icons, (v) => this.setRenderProp('icons', v));
        labelProp.apply(this._label, (v) => this.setRenderProp('label', v));
    }
    render() {
        return (h(Host, { key: 'c873200727206a653d840aafbccc0ad1bca1c937' }, h(IconFC, { key: 'd0ade37f5b4efb336b99a84845a109b4e51f99b6', icons: this.getRenderProp('icons'), label: this.getRenderProp('label') })));
    }
    static get watchers() { return {
        "_icons": ["watchIcons"],
        "_label": ["watchLabel"]
    }; }
};
KolIcon.style = {
    default: defaultStyleCss
};

export { KolIcon as kol_icon };
//# sourceMappingURL=kol-icon.entry.js.map
